import { fetchCampaignBuilderCampaigns } from "./campaignBuilderApi";

const SEED_CAMPAIGN_ID = "a1000000-0000-4000-8000-000000000001";

export async function resolveMarketingCampaignId(eventCampaignKey: string): Promise<string> {
  try {
    const { results } = await fetchCampaignBuilderCampaigns();
    const match = results.find((c) => String(c.event_campaign_key) === eventCampaignKey);
    if (match?.marketing_campaign_id) return String(match.marketing_campaign_id);
    if (results[0]?.marketing_campaign_id) return String(results[0].marketing_campaign_id);
  } catch {
    /* use seed fallback */
  }
  return SEED_CAMPAIGN_ID;
}
